import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, unref as _unref, vModelCheckbox as _vModelCheckbox, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent } from "vue";
const _hoisted_1 = { class: "customers-page" };
const _hoisted_2 = { class: "customers-layout" };
const _hoisted_3 = { class: "customers-list-panel" };
const _hoisted_4 = { class: "search-box" };
const _hoisted_5 = { class: "customers-list" };
const _hoisted_6 = {
    key: 0,
    class: "customer-items"
};
const _hoisted_7 = ["onClick"];
const _hoisted_8 = { class: "customer-name" };
const _hoisted_9 = {
    key: 1,
    class: "empty-state"
};
const _hoisted_10 = { class: "customer-details-panel" };
const _hoisted_11 = {
    key: 0,
    class: "details-content"
};
const _hoisted_12 = { class: "detail-header" };
const _hoisted_13 = { class: "form-row" };
const _hoisted_14 = { class: "form-group" };
const _hoisted_15 = ["value"];
const _hoisted_16 = { class: "form-group" };
const _hoisted_17 = ["value"];
const _hoisted_18 = { class: "form-group" };
const _hoisted_19 = ["value"];
const _hoisted_20 = { class: "form-row" };
const _hoisted_21 = { class: "form-group" };
const _hoisted_22 = ["value"];
const _hoisted_23 = { class: "form-group" };
const _hoisted_24 = ["value"];
const _hoisted_25 = { class: "form-group" };
const _hoisted_26 = ["value"];
const _hoisted_27 = { class: "form-group customer-note-group" };
const _hoisted_28 = { class: "label-with-button" };
const _hoisted_29 = ["disabled"];
const _hoisted_30 = { class: "employer-section" };
const _hoisted_31 = { class: "section-header" };
const _hoisted_32 = {
    key: 0,
    class: "employer-info"
};
const _hoisted_33 = { class: "employer-name" };
const _hoisted_34 = {
    key: 1,
    class: "no-employer"
};
const _hoisted_35 = { class: "dates-section" };
const _hoisted_36 = { class: "date-item" };
const _hoisted_37 = { class: "date-value" };
const _hoisted_38 = { class: "date-item" };
const _hoisted_39 = { class: "date-value" };
const _hoisted_40 = { class: "actions-row" };
const _hoisted_41 = { class: "dpa-section" };
const _hoisted_42 = { class: "dpa-warning" };
const _hoisted_43 = { key: 0 };
const _hoisted_44 = { class: "form-row" };
const _hoisted_45 = { class: "form-group" };
const _hoisted_46 = ["onUpdate:modelValue"];
const _hoisted_47 = { class: "form-group" };
const _hoisted_48 = ["onUpdate:modelValue"];
const _hoisted_49 = { class: "form-group" };
const _hoisted_50 = ["onUpdate:modelValue"];
const _hoisted_51 = { class: "form-row" };
const _hoisted_52 = { class: "form-group" };
const _hoisted_53 = ["value"];
const _hoisted_54 = { class: "form-group" };
const _hoisted_55 = ["onUpdate:modelValue"];
const _hoisted_56 = { class: "form-group" };
const _hoisted_57 = ["onUpdate:modelValue"];
const _hoisted_58 = { class: "form-row" };
const _hoisted_59 = { class: "form-group" };
const _hoisted_60 = ["onUpdate:modelValue"];
const _hoisted_61 = { class: "form-group" };
const _hoisted_62 = ["onUpdate:modelValue"];
const _hoisted_63 = { class: "form-group" };
const _hoisted_64 = ["onUpdate:modelValue"];
const _hoisted_65 = { class: "form-row" };
const _hoisted_66 = { class: "form-group full-width" };
const _hoisted_67 = { class: "aiop-code" };
const _hoisted_68 = { class: "form-row" };
const _hoisted_69 = { class: "form-group" };
const _hoisted_70 = ["onUpdate:modelValue"];
const _hoisted_71 = { class: "form-group" };
const _hoisted_72 = ["onUpdate:modelValue"];
const _hoisted_73 = { class: "form-group" };
const _hoisted_74 = ["onUpdate:modelValue"];
const _hoisted_75 = { class: "form-row" };
const _hoisted_76 = { class: "form-group" };
const _hoisted_77 = ["onUpdate:modelValue"];
const _hoisted_78 = { class: "form-group" };
const _hoisted_79 = ["onUpdate:modelValue"];
const _hoisted_80 = { class: "form-row" };
const _hoisted_81 = { class: "form-group" };
const _hoisted_82 = ["onUpdate:modelValue"];
const _hoisted_83 = { class: "form-group" };
const _hoisted_84 = ["onUpdate:modelValue"];
const _hoisted_85 = { class: "form-group" };
const _hoisted_86 = ["onUpdate:modelValue"];
const _hoisted_87 = { class: "form-row" };
const _hoisted_88 = { class: "form-group full-width" };
const _hoisted_89 = { class: "aiop-code" };
const _hoisted_90 = {
    key: 3,
    class: "data-section"
};
const _hoisted_91 = { class: "table-wrapper" };
const _hoisted_92 = { class: "detail-table" };
const _hoisted_93 = {
    key: 4,
    class: "data-section"
};
const _hoisted_94 = { class: "table-wrapper" };
const _hoisted_95 = { class: "detail-table" };
const _hoisted_96 = {
    key: 5,
    class: "data-section"
};
const _hoisted_97 = { class: "fact-card-wrapper" };
const _hoisted_98 = { class: "fact-card" };
const _hoisted_99 = ["onUpdate:modelValue"];
const _hoisted_100 = ["disabled"];
const _hoisted_101 = {
    key: 1,
    class: "empty-state"
};
const _hoisted_102 = { class: "search-box" };
const _hoisted_103 = { class: "employers-list" };
const _hoisted_104 = { key: 0 };
const _hoisted_105 = ["onClick"];
const _hoisted_106 = {
    key: 1,
    class: "empty-state"
};
const _hoisted_107 = { class: "credit-section" };
const _hoisted_108 = { class: "form-group" };
const _hoisted_109 = { class: "credit-history" };
const _hoisted_110 = { class: "table-wrapper" };
const _hoisted_111 = {
    key: 0,
    class: "detail-table"
};
const _hoisted_112 = {
    key: 1,
    class: "empty-state"
};
const _hoisted_113 = { class: "delete-confirm-group" };
const _hoisted_114 = { class: "checkbox-label" };
const _hoisted_115 = { class: "delete-confirm-group" };
const _hoisted_116 = { class: "confirm-hint" };
const _hoisted_117 = ["placeholder"];
const _hoisted_118 = ["disabled"];
const _hoisted_119 = { class: "customer-name-display" };
const _hoisted_120 = ["disabled"];
import { ref, computed, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useAdmin } from '@/composables/useAdmin';
import MGDialog from '@/components/elements/MGDialog.vue';
import ExpandableDataTable from '@/admin/components/ExpandableDataTable.vue';
import CustomerNotesDrawer from '@/admin/components/CustomerNotesDrawer.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'CustomersPage',
    setup(__props) {
        const admin = useAdmin();
        const route = useRoute();
        const router = useRouter();
        const customers = ref([]);
        const selectedCustomer = ref(null);
        const searchQuery = ref('');
        const customersLoading = ref(false);
        const customersError = ref(null);
        const showLinkEmployerModal = ref(false);
        const employerSearchQuery = ref('');
        const availableEmployers = ref([]);
        const employers = ref([]);
        const showSuccessToast = ref(false);
        const successMessage = ref('');
        const showErrorToast = ref(false);
        const errorMessage = ref('');
        const permissionGranted = ref(false);
        const policies = ref([]);
        const investments = ref([]);
        const moves = ref([]);
        const completedMoves = ref([]);
        const expandedPolicy = ref(null);
        const expandedInvestment = ref(null);
        const selfId = ref(null);
        const creditTransactions = ref([]);
        const payments = ref([]);
        const showManageCreditModal = ref(false);
        const creditAmount = ref('');
        const generatingMoves = ref(false);
        const policyColumns = [
            { key: 'provider.name', label: 'Provider' },
            { key: 'policyType.name', label: 'Type' },
            { key: 'policyNumber', label: 'Policy Number' },
            {
                key: 'insuredItems',
                label: 'Reg',
                formatter: (policy) => {
                    return policy.insuredItems?.[0]?.vehicleRegistration ||
                        policy.insuredItems?.[0]?.addressInsured ||
                        '-';
                }
            }
        ];
        const investmentColumns = [
            { key: 'provider.name', label: 'Provider' },
            { key: 'accountType.name', label: 'Type' },
            { key: 'accountNumber', label: 'Account Number' },
            {
                key: 'balance',
                label: 'Balance',
                formatter: (investment) => {
                    return investment.balance ? `£${investment.balance.toFixed(2)}` : '£0.00';
                }
            }
        ];
        const customerNotes = ref([]);
        const showNotesDrawer = ref(false);
        const notesLoading = ref(false);
        const noteMethodOptions = ['zendesk', 'phone', 'email', 'in-person', 'chat', 'other'];
        const noteReasonOptions = ['inquiry', 'complaint', 'follow-up', 'support', 'other'];
        // Baseline for the note dirty-check — the textarea binds straight to selectedCustomer.note
        const savedCustomerNote = ref('');
        const noteUpdating = ref(false);
        const showDeleteConfirm = ref(false);
        const showFinalDeleteConfirm = ref(false);
        const deleteConfirmText = ref('');
        const deleteAcknowledge = ref(false);
        const deleting = ref(false);
        const filteredCustomers = computed(() => {
            if (!searchQuery.value.trim()) {
                return customers.value;
            }
            const query = searchQuery.value.toLowerCase();
            return customers.value.filter((cust) => {
                const fullName = `${cust.person.firstName} ${cust.person.lastName}`.toLowerCase();
                const email = cust.person.email.toLowerCase();
                return fullName.includes(query) || email.includes(query) || cust.id.toLowerCase().includes(query);
            });
        });
        const filteredEmployers = computed(() => {
            if (!employerSearchQuery.value.trim()) {
                return employers.value;
            }
            const query = employerSearchQuery.value.toLowerCase();
            return employers.value.filter((emp) => emp.name.toLowerCase().includes(query) ||
                emp.id.toLowerCase().includes(query));
        });
        const deleteConfirmPhrase = computed(() => `DELETE ${selectedCustomer.value?.person.firstName} ${selectedCustomer.value?.person.lastName}`);
        const deleteConfirmValid = computed(() => deleteConfirmText.value === deleteConfirmPhrase.value);
        function proceedToFinalDeleteConfirm() {
            showDeleteConfirm.value = false;
            showFinalDeleteConfirm.value = true;
        }
        function confirmDeleteCustomer() {
            deleting.value = true;
            admin.deleteCustomer(selectedCustomer.value.id, () => {
                showFinalDeleteConfirm.value = false;
                deleteConfirmText.value = '';
                deleteAcknowledge.value = false;
                deleting.value = false;
                selectedCustomer.value = null;
                admin.getCustomers((data) => {
                    customers.value = data;
                });
                showToast('Customer deleted successfully');
            }, (error) => {
                deleting.value = false;
                showError(error);
            });
        }
        function showToast(message) {
            successMessage.value = message;
            showSuccessToast.value = true;
        }
        function showError(message) {
            errorMessage.value = message;
            showErrorToast.value = true;
        }
        function selectCustomer(customer) {
            // Reset permission and data when selecting new customer
            permissionGranted.value = false;
            creditAmount.value = '';
            selectedCustomer.value = customer;
            savedCustomerNote.value = customer.note || '';
            // Fetch detailed customer information from the API (always include facts)
            admin.getCustomerDetails(customer.id, true, (customerData) => {
                customerData.note = customerData.note || '';
                selectedCustomer.value = customerData;
                savedCustomerNote.value = customerData.note;
                // Pre-fetch all related data
                admin.getCustomerPolicies(customer.id, (data) => {
                    policies.value = data || [];
                });
                admin.getCustomerInvestments(customer.id, (data) => {
                    investments.value = data || [];
                });
                admin.getCustomerMoves(customer.id, (data) => {
                    moves.value = data || [];
                });
                admin.getCustomerCompletedMoves(customer.id, (data) => {
                    completedMoves.value = data || [];
                });
                // Fetch credit transactions
                admin.getCustomerCreditTransactions(customer.id, (data) => {
                    creditTransactions.value = data || [];
                });
                admin.getCustomerPayments(customer.id, (data) => {
                    payments.value = data || [];
                });
            });
        }
        function confirmLinkEmployer(employer) {
            admin.linkEmployerToCustomer(selectedCustomer.value.id, employer.id, () => {
                showLinkEmployerModal.value = false;
                employerSearchQuery.value = '';
                // Update selected customer with employer info
                selectedCustomer.value.employerID = employer.id;
                selectedCustomer.value.employer = employer;
                // Refresh customers list
                admin.getCustomers((data) => {
                    customers.value = data;
                });
                showToast('Employer linked successfully');
            }, (error) => {
                showError(error);
            });
        }
        function unlinkEmployer() {
            admin.linkEmployerToCustomer(selectedCustomer.value.id, null, () => {
                // Update selected customer
                selectedCustomer.value.employerID = null;
                selectedCustomer.value.employer = null;
                // Refresh customers list
                admin.getCustomers((data) => {
                    customers.value = data;
                });
                showToast('Employer unlinked successfully');
            }, (error) => {
                showError(error);
            });
        }
        function formatDate(dateString) {
            if (!dateString)
                return '';
            const date = new Date(dateString);
            return date.toLocaleDateString('en-GB', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit'
            });
        }
        function formatDateTime(dateString) {
            if (!dateString)
                return '';
            const date = new Date(dateString);
            return date.toLocaleString('en-GB', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit'
            });
        }
        function togglePolicyDetails(index) {
            expandedPolicy.value = expandedPolicy.value === index ? null : index;
        }
        function toggleInvestmentDetails(index) {
            expandedInvestment.value = expandedInvestment.value === index ? null : index;
        }
        function postFactCard() {
            if (!selectedCustomer.value || !selectedCustomer.value.facts) {
                showError('No facts to post');
                return;
            }
            generatingMoves.value = true;
            // Step 1: Post facts for the selected customer
            admin.postFactCard(selectedCustomer.value.id, selectedCustomer.value.facts, () => {
                // Step 2: Generate moves for the selected customer
                admin.generateMoves(selectedCustomer.value.id, () => {
                    // Step 3: Refresh selected customer to show updated facts
                    admin.getCustomerDetails(selectedCustomer.value.id, true, (customerData) => {
                        selectedCustomer.value = customerData;
                        // Step 4: Refresh moves for the selected customer
                        admin.getCustomerMoves(selectedCustomer.value.id, (data) => {
                            moves.value = data || [];
                            showToast('Moves generated successfully');
                            generatingMoves.value = false;
                        });
                    });
                }, (error) => {
                    showError(error);
                    generatingMoves.value = false;
                });
            }, (error) => {
                showError(error);
                generatingMoves.value = false;
            });
        }
        function addCredit() {
            if (!creditAmount.value || parseFloat(creditAmount.value) <= 0) {
                showError('Please enter a valid amount');
                return;
            }
            if (!selectedCustomer.value || !selectedCustomer.value.id) {
                showError('No customer selected');
                return;
            }
            const amount = parseFloat(creditAmount.value);
            admin.addCustomerCredit(selectedCustomer.value.id, amount, () => {
                // Refresh credit transactions after successful add
                admin.getCustomerCreditTransactions(selectedCustomer.value.id, (data) => {
                    creditTransactions.value = data || [];
                });
                showToast('Credit added successfully');
                creditAmount.value = '';
            }, (error) => {
                showError(error);
            });
        }
        function openNotesDrawer() {
            showNotesDrawer.value = true;
            notesLoading.value = true;
            admin.getCustomerNotes(selectedCustomer.value.id, (notes) => {
                customerNotes.value = notes || [];
                notesLoading.value = false;
            });
        }
        function closeNotesDrawer() {
            showNotesDrawer.value = false;
        }
        function handleAddNote(noteData) {
            noteData.customerID = selectedCustomer.value.id;
            noteData.addedByCustomerID = selfId.value;
            // This method is called from the CustomerNotesDrawer component
            // noteData already has validation done in the component
            admin.createCustomerNote(selectedCustomer.value.id, noteData, () => {
                showToast('Note added successfully');
                // Refresh notes list
                admin.getCustomerNotes(selectedCustomer.value.id, (notes) => {
                    customerNotes.value = notes || [];
                });
            }, (error) => {
                showError(error);
            });
        }
        function saveCustomerNote() {
            noteUpdating.value = true;
            const updateData = {
                note: selectedCustomer.value.note
            };
            admin.updateCustomerNote(selectedCustomer.value.id, updateData, () => {
                savedCustomerNote.value = selectedCustomer.value.note;
                showToast('Customer note saved successfully');
                noteUpdating.value = false;
            }, (error) => {
                showError(error);
                noteUpdating.value = false;
            });
        }
        onMounted(() => {
            console.log('Customers Page loaded');
            // Fetch current user's ID
            admin.getSelf((result) => {
                if (result && result.id) {
                    selfId.value = result.id;
                }
            });
            admin.getCustomers((data) => {
                customers.value = data;
                const preselect = route.query.customerId;
                if (preselect) {
                    const found = data.find((c) => c.id === preselect);
                    if (found)
                        selectCustomer(found);
                }
            });
            admin.getEmployers((data) => {
                employers.value = data;
            });
        });
        return (_ctx, _cache) => {
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_snackbar = _resolveComponent("v-snackbar");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _cache[23] || (_cache[23] = _createElementVNode("div", { class: "list-header" }, [
                            _createElementVNode("h2", null, "Customers")
                        ], -1)),
                        _createElementVNode("div", _hoisted_4, [
                            _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((searchQuery).value = $event)),
                                type: "text",
                                placeholder: "Search customers...",
                                class: "search-input"
                            }, null, 512), [
                                [_vModelText, searchQuery.value]
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_5, [
                            (filteredCustomers.value.length > 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredCustomers.value, (customer) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                            key: customer.id,
                                            class: _normalizeClass(["customer-item", { active: selectedCustomer.value && selectedCustomer.value.id === customer.id }]),
                                            onClick: ($event) => (selectCustomer(customer))
                                        }, [
                                            _createElementVNode("div", _hoisted_8, _toDisplayString(customer.person.firstName) + " " + _toDisplayString(customer.person.lastName), 1),
                                            _createElementVNode("div", {
                                                class: _normalizeClass(["customer-linked", { linked: customer.employerID }])
                                            }, _toDisplayString(customer.employerID ? 'Linked' : 'Not Linked'), 3)
                                        ], 10, _hoisted_7));
                                    }), 128))
                                ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_9, " No customers found "))
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                        (selectedCustomer.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                _createElementVNode("div", _hoisted_12, _toDisplayString(selectedCustomer.value.id), 1),
                                _createElementVNode("div", _hoisted_13, [
                                    _createElementVNode("div", _hoisted_14, [
                                        _cache[24] || (_cache[24] = _createElementVNode("label", null, "Title:", -1)),
                                        _createElementVNode("input", {
                                            value: selectedCustomer.value.person.title,
                                            type: "text",
                                            class: "form-input",
                                            readonly: ""
                                        }, null, 8, _hoisted_15)
                                    ]),
                                    _createElementVNode("div", _hoisted_16, [
                                        _cache[25] || (_cache[25] = _createElementVNode("label", null, "First Name:", -1)),
                                        _createElementVNode("input", {
                                            value: selectedCustomer.value.person.firstName,
                                            type: "text",
                                            class: "form-input",
                                            readonly: ""
                                        }, null, 8, _hoisted_17)
                                    ]),
                                    _createElementVNode("div", _hoisted_18, [
                                        _cache[26] || (_cache[26] = _createElementVNode("label", null, "Last Name:", -1)),
                                        _createElementVNode("input", {
                                            value: selectedCustomer.value.person.lastName,
                                            type: "text",
                                            class: "form-input",
                                            readonly: ""
                                        }, null, 8, _hoisted_19)
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_20, [
                                    _createElementVNode("div", _hoisted_21, [
                                        _cache[27] || (_cache[27] = _createElementVNode("label", null, "Email:", -1)),
                                        _createElementVNode("input", {
                                            value: selectedCustomer.value.person.email,
                                            type: "text",
                                            class: "form-input",
                                            readonly: ""
                                        }, null, 8, _hoisted_22)
                                    ]),
                                    _createElementVNode("div", _hoisted_23, [
                                        _cache[28] || (_cache[28] = _createElementVNode("label", null, "Mobile:", -1)),
                                        _createElementVNode("input", {
                                            value: selectedCustomer.value.person.mobilePhone,
                                            type: "text",
                                            class: "form-input",
                                            readonly: ""
                                        }, null, 8, _hoisted_24)
                                    ]),
                                    _createElementVNode("div", _hoisted_25, [
                                        _cache[29] || (_cache[29] = _createElementVNode("label", null, "DOB:", -1)),
                                        _createElementVNode("input", {
                                            value: formatDate(selectedCustomer.value.person.dob),
                                            type: "text",
                                            class: "form-input",
                                            readonly: ""
                                        }, null, 8, _hoisted_26)
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_27, [
                                    _createElementVNode("div", _hoisted_28, [
                                        _cache[30] || (_cache[30] = _createElementVNode("label", null, "Customer Note:", -1)),
                                        (selectedCustomer.value.note !== savedCustomerNote.value)
                                            ? (_openBlock(), _createElementBlock("button", {
                                                key: 0,
                                                class: "action-btn primary small",
                                                onClick: saveCustomerNote,
                                                disabled: noteUpdating.value
                                            }, _toDisplayString(noteUpdating.value ? 'Saving...' : 'Save'), 9, _hoisted_29))
                                            : _createCommentVNode("", true)
                                    ]),
                                    _withDirectives(_createElementVNode("textarea", {
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((selectedCustomer.value.note) = $event)),
                                        class: "form-textarea",
                                        rows: "3",
                                        placeholder: "Add a general note about this customer..."
                                    }, null, 512), [
                                        [_vModelText, selectedCustomer.value.note]
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_30, [
                                    _createElementVNode("div", _hoisted_31, [
                                        _cache[31] || (_cache[31] = _createElementVNode("label", null, "Employer:", -1)),
                                        _createElementVNode("button", {
                                            class: "action-btn secondary",
                                            onClick: _cache[2] || (_cache[2] = ($event) => (showLinkEmployerModal.value = true))
                                        }, " Link Employer ")
                                    ]),
                                    (selectedCustomer.value.employer)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                            _createElementVNode("div", _hoisted_33, _toDisplayString(selectedCustomer.value.employer.name), 1),
                                            _createElementVNode("button", {
                                                class: "action-btn danger small",
                                                onClick: unlinkEmployer
                                            }, " Unlink ")
                                        ]))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_34, " No employer linked "))
                                ]),
                                _createElementVNode("div", _hoisted_35, [
                                    _createElementVNode("div", _hoisted_36, [
                                        _cache[32] || (_cache[32] = _createElementVNode("label", null, "Signed Up:", -1)),
                                        _createElementVNode("div", _hoisted_37, _toDisplayString(formatDateTime(selectedCustomer.value.createDateTime)), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_38, [
                                        _cache[33] || (_cache[33] = _createElementVNode("label", null, "Last Logged In:", -1)),
                                        _createElementVNode("div", _hoisted_39, _toDisplayString(selectedCustomer.value.lastLoginDateTime ? formatDateTime(selectedCustomer.value.lastLoginDateTime) : 'Never'), 1)
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_40, [
                                    _createElementVNode("button", {
                                        class: "action-btn secondary",
                                        onClick: openNotesDrawer
                                    }, " Customer Notes "),
                                    _createElementVNode("button", {
                                        class: "action-btn secondary",
                                        onClick: _cache[3] || (_cache[3] = ($event) => (_unref(router).push('/admin/crm/customer/' + selectedCustomer.value.id)))
                                    }, " CRM "),
                                    _createElementVNode("button", {
                                        class: "action-btn secondary",
                                        onClick: _cache[4] || (_cache[4] = ($event) => (showManageCreditModal.value = true))
                                    }, " Manage Credit "),
                                    _createElementVNode("button", {
                                        class: "action-btn danger",
                                        onClick: _cache[5] || (_cache[5] = ($event) => (showDeleteConfirm.value = true))
                                    }, " Delete Customer ")
                                ]),
                                _createElementVNode("div", _hoisted_41, [
                                    _createElementVNode("label", _hoisted_42, [
                                        _withDirectives(_createElementVNode("input", {
                                            type: "checkbox",
                                            class: "form-checkbox",
                                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((permissionGranted).value = $event))
                                        }, null, 512), [
                                            [_vModelCheckbox, permissionGranted.value]
                                        ]),
                                        _cache[34] || (_cache[34] = _createElementVNode("span", null, "I have obtained explicit permission from the customer to view their details.", -1))
                                    ]),
                                    _cache[35] || (_cache[35] = _createElementVNode("p", { class: "dpa-text" }, " Section 170 of the Data Protection Act 2018 (DPA 2018) makes it a criminal offense to unlawfully obtain personal data. ", -1))
                                ]),
                                (permissionGranted.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                                        (payments.value && payments.value.length > 0)
                                            ? (_openBlock(), _createBlock(ExpandableDataTable, {
                                                key: 0,
                                                title: `Payments`,
                                                items: payments.value,
                                                columns: [
                                                    { key: 'amountInPence', label: 'Amount (£)', formatter: (payment) => `£${(payment.amountInPence / 100).toFixed(2)}` },
                                                    { key: 'createDateTime', label: 'Payment Date', formatter: (payment) => formatDateTime(payment.createDateTime) },
                                                    { key: 'paid', label: 'Paid' },
                                                    { key: 'productDescription', label: 'Description' }
                                                ]
                                            }, null, 8, ["items", "columns"]))
                                            : _createCommentVNode("", true),
                                        (policies.value && policies.value.length > 0)
                                            ? (_openBlock(), _createBlock(ExpandableDataTable, {
                                                key: 1,
                                                title: `Insurance`,
                                                items: policies.value,
                                                columns: policyColumns,
                                                "expanded-index": expandedPolicy.value,
                                                onToggleDetails: togglePolicyDetails
                                            }, {
                                                details: _withCtx(({ item: policy }) => [
                                                    _createElementVNode("div", _hoisted_44, [
                                                        _createElementVNode("div", _hoisted_45, [
                                                            _cache[36] || (_cache[36] = _createElementVNode("label", null, "Policy Number:", -1)),
                                                            _withDirectives(_createElementVNode("input", {
                                                                "onUpdate:modelValue": ($event) => ((policy.policyNumber) = $event),
                                                                class: "form-input",
                                                                readonly: ""
                                                            }, null, 8, _hoisted_46), [
                                                                [_vModelText, policy.policyNumber]
                                                            ])
                                                        ]),
                                                        _createElementVNode("div", _hoisted_47, [
                                                            _cache[37] || (_cache[37] = _createElementVNode("label", null, "Type:", -1)),
                                                            _withDirectives(_createElementVNode("input", {
                                                                "onUpdate:modelValue": ($event) => ((policy.policyType.name) = $event),
                                                                class: "form-input",
                                                                readonly: ""
                                                            }, null, 8, _hoisted_48), [
                                                                [_vModelText, policy.policyType.name]
                                                            ])
                                                        ]),
                                                        _createElementVNode("div", _hoisted_49, [
                                                            _cache[38] || (_cache[38] = _createElementVNode("label", null, "Provider:", -1)),
                                                            _withDirectives(_createElementVNode("input", {
                                                                "onUpdate:modelValue": ($event) => ((policy.provider.name) = $event),
                                                                class: "form-input",
                                                                readonly: ""
                                                            }, null, 8, _hoisted_50), [
                                                                [_vModelText, policy.provider.name]
                                                            ])
                                                        ])
                                                    ]),
                                                    _createElementVNode("div", _hoisted_51, [
                                                        _createElementVNode("div", _hoisted_52, [
                                                            _cache[39] || (_cache[39] = _createElementVNode("label", null, "Reg/Address:", -1)),
                                                            _createElementVNode("input", {
                                                                value: policy.insuredItems?.[0]?.vehicleRegistration || policy.insuredItems?.[0]?.addressInsured || '-',
                                                                class: "form-input",
                                                                readonly: ""
                                                            }, null, 8, _hoisted_53)
                                                        ]),
                                                        _createElementVNode("div", _hoisted_54, [
                                                            _cache[40] || (_cache[40] = _createElementVNode("label", null, "Premium (£):", -1)),
                                                            _withDirectives(_createElementVNode("input", {
                                                                "onUpdate:modelValue": ($event) => ((policy.annualPremium) = $event),
                                                                type: "number",
                                                                class: "form-input"
                                                            }, null, 8, _hoisted_55), [
                                                                [_vModelText, policy.annualPremium]
                                                            ])
                                                        ]),
                                                        _createElementVNode("div", _hoisted_56, [
                                                            _cache[41] || (_cache[41] = _createElementVNode("label", null, "Excess (£):", -1)),
                                                            _withDirectives(_createElementVNode("input", {
                                                                "onUpdate:modelValue": ($event) => ((policy.excess) = $event),
                                                                type: "number",
                                                                class: "form-input"
                                                            }, null, 8, _hoisted_57), [
                                                                [_vModelText, policy.excess]
                                                            ])
                                                        ])
                                                    ]),
                                                    _createElementVNode("div", _hoisted_58, [
                                                        _createElementVNode("div", _hoisted_59, [
                                                            _cache[42] || (_cache[42] = _createElementVNode("label", null, "No Claims Years:", -1)),
                                                            _withDirectives(_createElementVNode("input", {
                                                                "onUpdate:modelValue": ($event) => ((policy.noClaimsYears) = $event),
                                                                type: "number",
                                                                class: "form-input",
                                                                placeholder: "Enter No Claims Years"
                                                            }, null, 8, _hoisted_60), [
                                                                [_vModelText, policy.noClaimsYears]
                                                            ])
                                                        ]),
                                                        _createElementVNode("div", _hoisted_61, [
                                                            _cache[43] || (_cache[43] = _createElementVNode("label", null, "Start Date:", -1)),
                                                            _withDirectives(_createElementVNode("input", {
                                                                "onUpdate:modelValue": ($event) => ((policy.startDateString) = $event),
                                                                class: "form-input"
                                                            }, null, 8, _hoisted_62), [
                                                                [_vModelText, policy.startDateString]
                                                            ])
                                                        ]),
                                                        _createElementVNode("div", _hoisted_63, [
                                                            _cache[44] || (_cache[44] = _createElementVNode("label", null, "End Date:", -1)),
                                                            _withDirectives(_createElementVNode("input", {
                                                                "onUpdate:modelValue": ($event) => ((policy.endDateString) = $event),
                                                                class: "form-input"
                                                            }, null, 8, _hoisted_64), [
                                                                [_vModelText, policy.endDateString]
                                                            ])
                                                        ])
                                                    ]),
                                                    _createElementVNode("div", _hoisted_65, [
                                                        _createElementVNode("div", _hoisted_66, [
                                                            _cache[45] || (_cache[45] = _createElementVNode("label", null, "AIOP Object:", -1)),
                                                            _createElementVNode("code", _hoisted_67, _toDisplayString(JSON.stringify(policy, null, 2)), 1)
                                                        ])
                                                    ])
                                                ]),
                                                _: 1
                                            }, 8, ["items", "expanded-index"]))
                                            : _createCommentVNode("", true),
                                        (investments.value && investments.value.length > 0)
                                            ? (_openBlock(), _createBlock(ExpandableDataTable, {
                                                key: 2,
                                                title: `Investments`,
                                                items: investments.value,
                                                columns: investmentColumns,
                                                "expanded-index": expandedInvestment.value,
                                                onToggleDetails: toggleInvestmentDetails
                                            }, {
                                                details: _withCtx(({ item: investment }) => [
                                                    _createElementVNode("div", _hoisted_68, [
                                                        _createElementVNode("div", _hoisted_69, [
                                                            _cache[46] || (_cache[46] = _createElementVNode("label", null, "Account Number:", -1)),
                                                            _withDirectives(_createElementVNode("input", {
                                                                "onUpdate:modelValue": ($event) => ((investment.accountNumber) = $event),
                                                                class: "form-input",
                                                                readonly: ""
                                                            }, null, 8, _hoisted_70), [
                                                                [_vModelText, investment.accountNumber]
                                                            ])
                                                        ]),
                                                        _createElementVNode("div", _hoisted_71, [
                                                            _cache[47] || (_cache[47] = _createElementVNode("label", null, "Account Type:", -1)),
                                                            _withDirectives(_createElementVNode("input", {
                                                                "onUpdate:modelValue": ($event) => ((investment.accountType.name) = $event),
                                                                class: "form-input",
                                                                readonly: ""
                                                            }, null, 8, _hoisted_72), [
                                                                [_vModelText, investment.accountType.name]
                                                            ])
                                                        ]),
                                                        _createElementVNode("div", _hoisted_73, [
                                                            _cache[48] || (_cache[48] = _createElementVNode("label", null, "Provider:", -1)),
                                                            _withDirectives(_createElementVNode("input", {
                                                                "onUpdate:modelValue": ($event) => ((investment.provider.name) = $event),
                                                                class: "form-input",
                                                                readonly: ""
                                                            }, null, 8, _hoisted_74), [
                                                                [_vModelText, investment.provider.name]
                                                            ])
                                                        ])
                                                    ]),
                                                    _createElementVNode("div", _hoisted_75, [
                                                        _createElementVNode("div", _hoisted_76, [
                                                            _cache[49] || (_cache[49] = _createElementVNode("label", null, "Balance (£):", -1)),
                                                            _withDirectives(_createElementVNode("input", {
                                                                "onUpdate:modelValue": ($event) => ((investment.balance) = $event),
                                                                type: "number",
                                                                class: "form-input"
                                                            }, null, 8, _hoisted_77), [
                                                                [_vModelText, investment.balance]
                                                            ])
                                                        ]),
                                                        _createElementVNode("div", _hoisted_78, [
                                                            _cache[50] || (_cache[50] = _createElementVNode("label", null, "Allowance Used (£):", -1)),
                                                            _withDirectives(_createElementVNode("input", {
                                                                "onUpdate:modelValue": ($event) => ((investment.taxYearAllowanceUsed) = $event),
                                                                type: "number",
                                                                class: "form-input"
                                                            }, null, 8, _hoisted_79), [
                                                                [_vModelText, investment.taxYearAllowanceUsed]
                                                            ])
                                                        ])
                                                    ]),
                                                    _createElementVNode("div", _hoisted_80, [
                                                        _createElementVNode("div", _hoisted_81, [
                                                            _cache[51] || (_cache[51] = _createElementVNode("label", null, "Personal Contribution (£):", -1)),
                                                            _withDirectives(_createElementVNode("input", {
                                                                "onUpdate:modelValue": ($event) => ((investment.personalMonthlyContribution) = $event),
                                                                type: "number",
                                                                class: "form-input"
                                                            }, null, 8, _hoisted_82), [
                                                                [_vModelText, investment.personalMonthlyContribution]
                                                            ])
                                                        ]),
                                                        _createElementVNode("div", _hoisted_83, [
                                                            _cache[52] || (_cache[52] = _createElementVNode("label", null, "Employer Contribution (£):", -1)),
                                                            _withDirectives(_createElementVNode("input", {
                                                                "onUpdate:modelValue": ($event) => ((investment.employerMonthlyContribution) = $event),
                                                                type: "number",
                                                                class: "form-input"
                                                            }, null, 8, _hoisted_84), [
                                                                [_vModelText, investment.employerMonthlyContribution]
                                                            ])
                                                        ]),
                                                        _createElementVNode("div", _hoisted_85, [
                                                            _cache[53] || (_cache[53] = _createElementVNode("label", null, "Retirement Age:", -1)),
                                                            _withDirectives(_createElementVNode("input", {
                                                                "onUpdate:modelValue": ($event) => ((investment.retirementAge) = $event),
                                                                type: "number",
                                                                class: "form-input"
                                                            }, null, 8, _hoisted_86), [
                                                                [_vModelText, investment.retirementAge]
                                                            ])
                                                        ])
                                                    ]),
                                                    _createElementVNode("div", _hoisted_87, [
                                                        _createElementVNode("div", _hoisted_88, [
                                                            _cache[54] || (_cache[54] = _createElementVNode("label", null, "AIOP Object:", -1)),
                                                            _createElementVNode("code", _hoisted_89, _toDisplayString(JSON.stringify(investment, null, 2)), 1)
                                                        ])
                                                    ])
                                                ]),
                                                _: 1
                                            }, 8, ["items", "expanded-index"]))
                                            : _createCommentVNode("", true),
                                        (completedMoves.value && completedMoves.value.length > 0)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_90, [
                                                _createElementVNode("h4", null, "Completed Moves (" + _toDisplayString(completedMoves.value.length) + ")", 1),
                                                _createElementVNode("div", _hoisted_91, [
                                                    _createElementVNode("table", _hoisted_92, [
                                                        _cache[55] || (_cache[55] = _createElementVNode("thead", null, [
                                                            _createElementVNode("tr", null, [
                                                                _createElementVNode("th", null, "Completed Moves"),
                                                                _createElementVNode("th", null, "Description")
                                                            ])
                                                        ], -1)),
                                                        _createElementVNode("tbody", null, [
                                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(completedMoves.value, (move, index) => {
                                                                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                                                    _createElementVNode("td", null, _toDisplayString(move.completedMoves || '-'), 1),
                                                                    _createElementVNode("td", null, _toDisplayString(move.description || '-'), 1)
                                                                ]));
                                                            }), 128))
                                                        ])
                                                    ])
                                                ])
                                            ]))
                                            : _createCommentVNode("", true),
                                        (moves.value && moves.value.length > 0)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_93, [
                                                _createElementVNode("h4", null, "Pending Moves (" + _toDisplayString(moves.value.length) + ")", 1),
                                                _createElementVNode("div", _hoisted_94, [
                                                    _createElementVNode("table", _hoisted_95, [
                                                        _cache[56] || (_cache[56] = _createElementVNode("thead", null, [
                                                            _createElementVNode("tr", null, [
                                                                _createElementVNode("th", null, "Pending Moves"),
                                                                _createElementVNode("th", null, "Description")
                                                            ])
                                                        ], -1)),
                                                        _createElementVNode("tbody", null, [
                                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(moves.value, (move, index) => {
                                                                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                                                    _createElementVNode("td", null, _toDisplayString(move.pendingMoves || '-'), 1),
                                                                    _createElementVNode("td", null, _toDisplayString(move.description || '-'), 1)
                                                                ]));
                                                            }), 128))
                                                        ])
                                                    ])
                                                ])
                                            ]))
                                            : _createCommentVNode("", true),
                                        (selectedCustomer.value.facts)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_96, [
                                                _cache[57] || (_cache[57] = _createElementVNode("h4", null, "Fact Card", -1)),
                                                _createElementVNode("div", _hoisted_97, [
                                                    _createElementVNode("div", _hoisted_98, [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(selectedCustomer.value.facts), (name) => {
                                                            return (_openBlock(), _createElementBlock("div", {
                                                                key: name,
                                                                class: "fact-row"
                                                            }, [
                                                                _createElementVNode("label", null, _toDisplayString(name) + ":", 1),
                                                                _withDirectives(_createElementVNode("input", {
                                                                    "onUpdate:modelValue": ($event) => ((selectedCustomer.value.facts[name]) = $event),
                                                                    class: "form-input"
                                                                }, null, 8, _hoisted_99), [
                                                                    [_vModelText, selectedCustomer.value.facts[name]]
                                                                ])
                                                            ]));
                                                        }), 128))
                                                    ])
                                                ]),
                                                _createElementVNode("button", {
                                                    class: "action-btn secondary",
                                                    onClick: postFactCard,
                                                    disabled: generatingMoves.value
                                                }, _toDisplayString(generatingMoves.value ? 'Generating...' : 'Generate Moves'), 9, _hoisted_100)
                                            ]))
                                            : _createCommentVNode("", true)
                                    ]))
                                    : _createCommentVNode("", true)
                            ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_101, " Select a customer to view details "))
                    ])
                ]),
                _createVNode(CustomerNotesDrawer, {
                    show: showNotesDrawer.value,
                    notes: customerNotes.value,
                    loading: notesLoading.value,
                    "method-options": noteMethodOptions,
                    "reason-options": noteReasonOptions,
                    customers: customers.value,
                    onClose: closeNotesDrawer,
                    onAddNote: handleAddNote,
                    onError: showError
                }, null, 8, ["show", "notes", "loading", "customers"]),
                _createVNode(MGDialog, {
                    modelValue: showLinkEmployerModal.value,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((showLinkEmployerModal).value = $event)),
                    title: "Link Employer",
                    "max-width": "500px",
                    "content-height": "400px"
                }, {
                    content: _withCtx(() => [
                        _createElementVNode("div", _hoisted_102, [
                            _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((employerSearchQuery).value = $event)),
                                type: "text",
                                placeholder: "Search employers...",
                                class: "search-input"
                            }, null, 512), [
                                [_vModelText, employerSearchQuery.value]
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_103, [
                            (filteredEmployers.value.length > 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_104, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredEmployers.value, (employer) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                            key: employer.id,
                                            class: "employer-option",
                                            onClick: ($event) => (confirmLinkEmployer(employer))
                                        }, _toDisplayString(employer.name), 9, _hoisted_105));
                                    }), 128))
                                ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_106, " No employers found "))
                        ])
                    ]),
                    actions: _withCtx(() => [
                        _createElementVNode("button", {
                            class: "action-btn secondary",
                            onClick: _cache[8] || (_cache[8] = ($event) => (showLinkEmployerModal.value = false))
                        }, "Cancel")
                    ]),
                    _: 1
                }, 8, ["modelValue"]),
                _createVNode(MGDialog, {
                    modelValue: showManageCreditModal.value,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((showManageCreditModal).value = $event)),
                    title: "Manage Customer Credit",
                    "max-width": "600px",
                    "content-height": "400px"
                }, {
                    content: _withCtx(() => [
                        _createElementVNode("div", _hoisted_107, [
                            _cache[59] || (_cache[59] = _createElementVNode("h4", null, "Add Credit", -1)),
                            _createElementVNode("div", _hoisted_108, [
                                _cache[58] || (_cache[58] = _createElementVNode("label", null, "Amount (£):", -1)),
                                _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((creditAmount).value = $event)),
                                    type: "number",
                                    placeholder: "Enter amount",
                                    class: "form-input",
                                    step: "0.01"
                                }, null, 512), [
                                    [_vModelText, creditAmount.value]
                                ])
                            ]),
                            _createElementVNode("button", {
                                class: "action-btn primary",
                                onClick: addCredit
                            }, "Add Credit")
                        ]),
                        _createElementVNode("div", _hoisted_109, [
                            _cache[61] || (_cache[61] = _createElementVNode("h4", null, "Credit Transaction History", -1)),
                            _createElementVNode("div", _hoisted_110, [
                                (creditTransactions.value && creditTransactions.value.length > 0)
                                    ? (_openBlock(), _createElementBlock("table", _hoisted_111, [
                                        _cache[60] || (_cache[60] = _createElementVNode("thead", null, [
                                            _createElementVNode("tr", null, [
                                                _createElementVNode("th", null, "Date"),
                                                _createElementVNode("th", null, "Amount (£)")
                                            ])
                                        ], -1)),
                                        _createElementVNode("tbody", null, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(creditTransactions.value, (transaction) => {
                                                return (_openBlock(), _createElementBlock("tr", {
                                                    key: transaction.id
                                                }, [
                                                    _createElementVNode("td", null, _toDisplayString(formatDateTime(transaction.createdDateTime)), 1),
                                                    _createElementVNode("td", null, _toDisplayString(transaction.amount.toFixed(2)), 1)
                                                ]));
                                            }), 128))
                                        ])
                                    ]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_112, " No credit transactions yet "))
                            ])
                        ])
                    ]),
                    actions: _withCtx(() => [
                        _createElementVNode("button", {
                            class: "action-btn secondary",
                            onClick: _cache[11] || (_cache[11] = ($event) => (showManageCreditModal.value = false))
                        }, "Close")
                    ]),
                    _: 1
                }, 8, ["modelValue"]),
                _createVNode(MGDialog, {
                    modelValue: showDeleteConfirm.value,
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event) => ((showDeleteConfirm).value = $event)),
                    title: "Delete Customer",
                    "max-width": "500px"
                }, {
                    content: _withCtx(() => [
                        _cache[65] || (_cache[65] = _createElementVNode("p", { class: "warning-text" }, " ⚠️ This action cannot be undone. All data associated with this customer will be permanently deleted. ", -1)),
                        _createElementVNode("div", _hoisted_113, [
                            _createElementVNode("label", _hoisted_114, [
                                _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event) => ((deleteAcknowledge).value = $event)),
                                    type: "checkbox",
                                    class: "form-checkbox"
                                }, null, 512), [
                                    [_vModelCheckbox, deleteAcknowledge.value]
                                ]),
                                _cache[62] || (_cache[62] = _createTextVNode(" I understand the consequences of this action "))
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_115, [
                            _cache[64] || (_cache[64] = _createElementVNode("label", null, "Type to confirm deletion:", -1)),
                            _createElementVNode("div", _hoisted_116, [
                                _cache[63] || (_cache[63] = _createTextVNode(" Type: ")),
                                _createElementVNode("strong", null, _toDisplayString(deleteConfirmPhrase.value), 1)
                            ]),
                            _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event) => ((deleteConfirmText).value = $event)),
                                type: "text",
                                class: "form-input",
                                placeholder: deleteConfirmPhrase.value
                            }, null, 8, _hoisted_117), [
                                [_vModelText, deleteConfirmText.value]
                            ])
                        ])
                    ]),
                    actions: _withCtx(() => [
                        _createElementVNode("button", {
                            class: "action-btn danger",
                            disabled: !deleteAcknowledge.value || !deleteConfirmValid.value,
                            onClick: proceedToFinalDeleteConfirm
                        }, " Proceed to Delete ", 8, _hoisted_118),
                        _createElementVNode("button", {
                            class: "action-btn secondary",
                            onClick: _cache[15] || (_cache[15] = ($event) => (showDeleteConfirm.value = false))
                        }, "Cancel")
                    ]),
                    _: 1
                }, 8, ["modelValue"]),
                _createVNode(MGDialog, {
                    modelValue: showFinalDeleteConfirm.value,
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event) => ((showFinalDeleteConfirm).value = $event)),
                    title: "Confirm Deletion",
                    "max-width": "500px"
                }, {
                    content: _withCtx(() => [
                        _cache[66] || (_cache[66] = _createElementVNode("p", { class: "final-warning-text" }, " ⚠️ You are about to permanently delete: ", -1)),
                        _createElementVNode("div", _hoisted_119, _toDisplayString(selectedCustomer.value?.person.firstName) + " " + _toDisplayString(selectedCustomer.value?.person.lastName), 1),
                        _cache[67] || (_cache[67] = _createElementVNode("p", { class: "final-warning-note" }, " This action cannot be undone. All associated data will be deleted permanently. ", -1))
                    ]),
                    actions: _withCtx(() => [
                        _createElementVNode("button", {
                            class: "action-btn danger",
                            disabled: deleting.value,
                            onClick: confirmDeleteCustomer
                        }, _toDisplayString(deleting.value ? 'Deleting...' : 'Yes, Delete Permanently'), 9, _hoisted_120),
                        _createElementVNode("button", {
                            class: "action-btn secondary",
                            onClick: _cache[17] || (_cache[17] = ($event) => (showFinalDeleteConfirm.value = false))
                        }, "Cancel")
                    ]),
                    _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_v_snackbar, {
                    modelValue: showSuccessToast.value,
                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event) => ((showSuccessToast).value = $event)),
                    timeout: 3000,
                    location: "bottom",
                    color: "success"
                }, {
                    actions: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                            icon: "mdi-close",
                            size: "small",
                            onClick: _cache[19] || (_cache[19] = ($event) => (showSuccessToast.value = false))
                        })
                    ]),
                    default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(successMessage.value) + " ", 1)
                    ]),
                    _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_v_snackbar, {
                    modelValue: showErrorToast.value,
                    "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event) => ((showErrorToast).value = $event)),
                    timeout: 4000,
                    location: "bottom",
                    color: "error"
                }, {
                    actions: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                            icon: "mdi-close",
                            size: "small",
                            onClick: _cache[21] || (_cache[21] = ($event) => (showErrorToast.value = false))
                        })
                    ]),
                    default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(errorMessage.value) + " ", 1)
                    ]),
                    _: 1
                }, 8, ["modelValue"])
            ]));
        };
    }
});
